/* eslint-disable no-extend-native */

const root = typeof window !== "undefined" ? window : {};

if (!root.globalThis) {
  root.globalThis = root;
}

if (typeof Object.hasOwn !== "function") {
  Object.defineProperty(Object, "hasOwn", {
    value(object, property) {
      if (object == null) {
        throw new TypeError("Cannot convert undefined or null to object");
      }
      return Object.prototype.hasOwnProperty.call(Object(object), property);
    },
    configurable: true,
    writable: true,
  });
}

if (typeof Object.fromEntries !== "function") {
  Object.defineProperty(Object, "fromEntries", {
    value(entries) {
      const object = {};
      for (const [key, value] of entries) {
        object[key] = value;
      }
      return object;
    },
    configurable: true,
    writable: true,
  });
}

if (typeof root.queueMicrotask !== "function") {
  root.queueMicrotask = (callback) => {
    Promise.resolve()
      .then(callback)
      .catch((error) => {
        setTimeout(() => {
          throw error;
        }, 0);
      });
  };
}

if (typeof Array.prototype.at !== "function") {
  Object.defineProperty(Array.prototype, "at", {
    value(index) {
      const length = this.length >>> 0;
      const relativeIndex = Math.trunc(Number(index)) || 0;
      const targetIndex =
        relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
      return targetIndex < 0 || targetIndex >= length
        ? undefined
        : this[targetIndex];
    },
    configurable: true,
    writable: true,
  });
}

if (typeof Array.prototype.flat !== "function") {
  Object.defineProperty(Array.prototype, "flat", {
    value(depth = 1) {
      const flattenDepth = Math.trunc(Number(depth)) || 0;
      const flatten = (items, currentDepth) =>
        items.reduce((acc, item) => {
          if (Array.isArray(item) && currentDepth < flattenDepth) {
            acc.push(...flatten(item, currentDepth + 1));
          } else {
            acc.push(item);
          }
          return acc;
        }, []);

      return flatten(Array.prototype.slice.call(this), 0);
    },
    configurable: true,
    writable: true,
  });
}

if (typeof Array.prototype.flatMap !== "function") {
  Object.defineProperty(Array.prototype, "flatMap", {
    value(callback, thisArg) {
      return Array.prototype.map.call(this, callback, thisArg).flat(1);
    },
    configurable: true,
    writable: true,
  });
}

const cloneFallback = (value, seen = new WeakMap()) => {
  if (value === null || typeof value !== "object") return value;
  if (seen.has(value)) return seen.get(value);

  if (value instanceof Date) return new Date(value.getTime());
  if (value instanceof RegExp) return new RegExp(value.source, value.flags);

  if (value instanceof Map) {
    const map = new Map();
    seen.set(value, map);
    value.forEach((itemValue, itemKey) => {
      map.set(cloneFallback(itemKey, seen), cloneFallback(itemValue, seen));
    });
    return map;
  }

  if (value instanceof Set) {
    const set = new Set();
    seen.set(value, set);
    value.forEach((itemValue) => {
      set.add(cloneFallback(itemValue, seen));
    });
    return set;
  }

  if (Array.isArray(value)) {
    const array = [];
    seen.set(value, array);
    value.forEach((item, index) => {
      array[index] = cloneFallback(item, seen);
    });
    return array;
  }

  const cloned = Object.create(Object.getPrototypeOf(value));
  seen.set(value, cloned);
  Reflect.ownKeys(value).forEach((key) => {
    cloned[key] = cloneFallback(value[key], seen);
  });
  return cloned;
};

if (typeof root.structuredClone !== "function") {
  root.structuredClone = cloneFallback;
}
